import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation, inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

export interface StepProgress {
  id: number;
  title: string;
  step: number;
  active: boolean;
}

@Component({
  selector: 'step-progress',
  imports: [NgClass, NgStyle],
  templateUrl: './step-progress.component.html',
  styleUrl: './step-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class StepProgressComponent implements OnChanges {
  protected readonly translocoService: TranslocoService = inject(TranslocoService);

  @Input() class: string | string[] | Record<string, boolean> = '';
  @Input() style: Record<string, any> | null = null;
  @Input() steps: StepProgress[] = [];

  ngOnChanges(_changes: SimpleChanges) {}

  trackByFn(index: number, item: any): any {
    return `${index}_${item?.id}`;
  }
}
